export function getBook (state){
  return state.book
}

export function getCategories (state){
  return state.categories
}